// extracted by mini-css-extract-plugin
export default {"time":"OrderDate-module_time_ef0287","date":"OrderDate-module_date_ced7f5","duration":"OrderDate-module_duration_d64399","stack":"OrderDate-module_stack_d01666"};